<template>
  <div>
    <CreateOrEditAdminPurchase ref="createOrEditDialog" @submitDialog="GetTableList" />

    <CreateOrEditTenant ref="createOrEditTenant" @submitDialog="GetTableList" />

    <div class="PageHeader">
      <el-breadcrumb>
        <el-breadcrumb-item v-if="SearchData.quality_type == 1">
          原料求购
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="SearchData.quality_type == 2">
          零切交易
        </el-breadcrumb-item>
        <el-breadcrumb-item v-if="SearchData.quality_type == 3">
          锻件定制
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="HeaderButtons">
        <el-button v-if="$store.getters.checkPermission('admin_purchase.edit')" type="success" size="small"
          @click="onlineBatch">{{ l("上架") }}</el-button>
        <el-button v-if="$store.getters.checkPermission('admin_purchase.edit')" type="danger" size="small"
          @click="offlineBatch">{{ l("下架") }}</el-button>
      </div>
    </div>
    <div class="PageContent">
      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="4">
          <label>code</label>
          <el-input placeholder="请输入code" v-model="SearchData.code" clearable @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"></el-input>
        </el-col>
        <el-col :span="4">
          <label>{{ l("标题") }}</label>
          <el-input :placeholder="l('请输入') + l('标题')" v-model="SearchData.title" clearable @clear="GetTableList(true)"
            @keyup.enter.native="GetTableList(true)"></el-input>
        </el-col>

        <el-col :span="4">
          <label>企业</label>
          <el-select v-model="SearchData.tenant_id" filterable clearable remote reserve-keyword placeholder="请输入企业名"
            :remote-method="remoteMethod" :loading="tenant_loading" @change="GetTableList(true)">
            <el-option v-for="item in tenant_list" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="4">
          <label>{{ l("状态") }}</label>
          <el-select clearable v-model="SearchData.status" @change="GetTableList(true)">
            <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
      </el-row>

      <el-row class="TableSearchRow" type="flex" :gutter="20">
        <el-col :span="8">
          <label>发布时间</label>
          <div style="display: flex;align-items: center">
            <el-date-picker v-model="SearchData.start_date" type="date" align="right" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" @change="GetTableList(true)">
            </el-date-picker>
            ~
            <el-date-picker v-model="SearchData.end_date" type="date" align="right" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" @change="GetTableList(true)">
            </el-date-picker>
          </div>
        </el-col>

        <!-- 管理员的额外筛选框 -->
        <el-col v-if="$store.getters.checkRole(3001) || $store.getters.checkRole(3002)" :span="3">
          <label>{{ l("业务员") }}</label>
          <el-select clearable v-model="SearchData.manager_shichang_id" @change="GetTableList(true)">
            <el-option v-for="item in manager_shichangList" :key="item.id" :label="item.display_name"
              :value="item.id"></el-option>
          </el-select>
        </el-col>


        <el-col :span="3">
          <el-button type="primary" icon="el-icon-search" round @click="GetTableList(true)">{{ l("查询") }}</el-button>
        </el-col>
      </el-row>

      <el-table :data="TableList" :stripe="true" @selection-change="HandleSelectionChange"
        @sort-change="HandleSortChange">
        <TableOperation :width="80" :operationList="[
          {
            is_show: (row) => true,
            label: l('详情'),
            command: 'ViewItem',
          },
        ]" @handleOperation="HandleOperation" />

        <el-table-column type="selection" width="55" fixed> </el-table-column>

        <el-table-column prop="title" :label="l('标题')" min-width="180" show-overflow-tooltip fixed></el-table-column>

        <el-table-column v-if="SearchData.quality_type == 3" key="forge_type" :label="l('类型')" width="80">
          <template slot-scope="scope">
            {{
              $utils.listFilter(
                $store.state.basicInfo.forge_typeList,
                scope.row.forge_type
              )
            }}
          </template>
        </el-table-column>
        <!-- <el-table-column label="图片" width="100">
          <template slot-scope="scope">
            <div class="ImageInTable">
              <el-image
                v-if="scope.row.img_array[0]"
                :src="scope.row.img_array[0]"
                fit="contain"
                :preview-src-list="scope.row.img_array"
              ></el-image>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column :label="l('数量')" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.specification_amount[0].amount
            }}{{ scope.row.specification_amount[0].unit }}
          </template>
        </el-table-column>

        <el-table-column label="发布者" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.belong_to_me">
              <template v-if="scope.row.tenant">{{
                scope.row.tenant.name
              }}</template>
              <template v-if="scope.row.user">
                {{ scope.row.user.display_name }}
                {{ scope.row.user.mobile }}
              </template>
            </template>
            <template v-else>
              <div style="color: #999">属于其他业务员</div>
            </template>
          </template>
        </el-table-column>

        <el-table-column :label="l('状态')" width="100">
          <template slot-scope="scope">
            <div :class="[
              $utils.listFilter(statusList, scope.row.status, 'class'),
            ]">
              {{ $utils.listFilter(statusList, scope.row.status) }}
            </div>
          </template>
        </el-table-column>

        <el-table-column :label="l('截止日期')" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.is_expire" style="color: #999">{{
              l("已截止")
            }}</span>
            <span v-else>{{ scope.row.expire_time.slice(0, 10) }}</span>
          </template>
        </el-table-column>


        <el-table-column v-if="$store.getters.checkRole(3001) || $store.getters.checkRole(3002)" :label="l('业务员')"
          width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              {{ $utils.listFilter(manager_shichangList, scope.row.user.manager_shichang_id, "display_name") }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="报价情况" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.auth_count" class="ViewLink" @click="showBusiness(scope.row)">{{ scope.row.auth_count }}家已报价</span>
            <span v-else style="color: #999">暂无报价</span>
          </template>
        </el-table-column>
        <el-table-column label="推广" width="80" prop="recommend_level" sortable="custom">
          <template slot-scope="scope">
            <el-checkbox v-model="scope.row.recommend_level" :true-label="1" :false-label="0" :disabled="!$store.getters.checkPermission('admin_purchase.recommend')
              " @change="changeRecommend(scope.row)"></el-checkbox>
          </template>
        </el-table-column>

        <!-- <el-table-column label="业务员" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.manager.display_name }}
          </template>
        </el-table-column> -->

        <el-table-column prop="created_time" label="发布时间" sortable="custom" width="170"></el-table-column>
      </el-table>
      <el-pagination background @size-change="HandleSizeChange" @current-change="HandleCurrentChange"
        :current-page="CurrentPage" :page-sizes="PageSizeList" :page-size="PageSize"
        layout="total, prev, pager, next, jumper" :total="TotalCount"></el-pagination>
    </div>
    <el-dialog :title="l('报价记录')" :visible.sync="businessDialogVisible" :destroy-on-close="true" width="1200px">
      <BusinessList v-if="businessDialogVisible" :api_url="business_api_url" :manager_caigouList="manager_caigouList" :nowShowBusinessRow="nowShowBusinessRow" :encryptLevel="encryptLevel"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="businessDialogVisible = false">{{
          l("取 消")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
import CreateOrEditAdminPurchase from "./operation/CreateOrEditAdminPurchase.vue";
import CreateOrEditTenant from "@/views/admin_tenant/operation/CreateOrEditTenant.vue";
import BusinessList from "@/components/common/BusinessList.vue";

export default {
  name: "AdminPurchase",
  components: {
    CreateOrEditAdminPurchase,
    CreateOrEditTenant,
    BusinessList,
  },
  mixins: [tableMixin],
  data() {
    return {
      SearchData: {
        code: "",
        title: "",
        tenant_id: "",
        category_id: null,
        quality_type: null,
        status: null,
        start_date: "",
        end_date: ""
      },
      tenant_loading: false,
      tenant_list: [],
      statusList: [
        {
          id: -1,
          name: this.l("已下架"),
          class: "color-danger",
        },
        {
          id: 0,
          name: this.l("待审核"),
          class: "color-warning",
        },
        {
          id: 1,
          name: this.l("已上架"),
          class: "color-success",
        },
      ],

      business_api_url: "",
      encryptLevel: null,
      businessDialogVisible: false,
      manager_shichangList: [],
      manager_caigouList: [],

      nowShowBusinessRow: null,//目前正在展示BusinessList的row

    };
  },
  created() {
    if (this.$route.name == "admin_purchase_material") {
      this.SearchData.quality_type = 1;
    }
    if (this.$route.name == "admin_purchase_piece") {
      this.SearchData.quality_type = 2;
    } else if (this.$route.name == "admin_purchase_forging") {
      this.SearchData.quality_type = 3;
    }
  },
  mounted() {
    if (this.$route.query.status) {
      this.SearchData.status = Number(this.$route.query.status);
    }
    if (this.$route.query.code) {
      this.SearchData.code = this.$route.query.code;
    }
    this.remoteMethod();

    this.axios
      .get("/api/admin_user/backend_user_simple_list/", {
        params: {
          role: 3004
        },
      })
      .then((data) => {
        this.manager_shichangList = data;
      });

    this.axios
      .get("/api/admin_user/backend_user_simple_list/", {
        params: {
          role: 3005
        },
      })
      .then((data) => {
        this.manager_caigouList = data;
      });
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_purchase/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results.map((item) => {
            item.img_array = JSON.parse(item.img_array);
            return item;
          });
        });
    },
    viewTenant(item) {
      this.$refs.createOrEditTenant.Type = "View";
      this.$refs.createOrEditTenant.Show({ id: item.tenant_id });
    },
    changeRecommend(item) {
      this.$confirm(
        `是否${item.recommend_level ? "推广" : "解除推广"}【${item.title}】?`,
        "",
        {
          type: "warning",
        }
      )
        .then(() => {
          this.axios
            .put(`/api/admin_purchase/${item.code}/recommend/`, {
              recommend_level: item.recommend_level,
            })
            .then((response) => {
              this.GetTableList();
            })
            .catch(() => {
              this.GetTableList();
            });
        })
        .catch(() => {
          this.GetTableList();
        });
    },

    onlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待上架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length
        }${this.l("项")}${this.l("上架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/admin_purchase/bulk_on/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },
    offlineBatch() {
      if (!this.MultipleSelection.length) {
        return this.$message.warning(this.l("请在列表中勾选待下架的内容"));
      }
      this.$confirm(
        `${this.l("是否将")}${this.l("选中")}${this.MultipleSelection.length
        }${this.l("项")}${this.l("下架")}?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(
            `/api/admin_purchase/bulk_off/`,
            this.MultipleSelection.map((item) => {
              return {
                code: item.code,
              };
            })
          )
          .then((response) => {
            this.GetTableList();
          });
      });
    },

    showBusiness(item) {
      this.nowShowBusinessRow = item;
      //后管用户
      if(this.$store.getters.checkRole(3001)||this.$store.getters.checkRole(3002)){
        this.encryptLevel = 0;
        this.business_api_url = `/api/admin_purchase/${item.code}/business_list/`;
      }
      //非后管用户
      else if(this.$store.getters.checkRole(3004)){
        this.encryptLevel = 1;
        this.business_api_url = `/api/visitor_purchase/${item.code}/salesman_business_list/`;
      }
      this.businessDialogVisible = true;
    },
    remoteMethod(query) {
      this.axios
        .get("/api/admin_tenant/simple_list/", {
          params: {
            name: query,
            size: 20,
          },
        })
        .then((data) => {
          this.tenant_list = data.results;
        });
    },
  },
};
</script>


<style scoped lang="scss"></style>
